export const BOOKING_STATUS = {
    UPCOMING: "upcoming",
    COMPLETED: "completed",
    AUTO_COMPLETED: "auto-completed",
    CANCELED: "canceled",
    DID_NOT_ATTEND: "dna",
};
export var ADD_ON_CHARGE_MODE;
(function (ADD_ON_CHARGE_MODE) {
    ADD_ON_CHARGE_MODE["WORKFLOW"] = "workflow";
    ADD_ON_CHARGE_MODE["INVOICE"] = "invoice";
})(ADD_ON_CHARGE_MODE || (ADD_ON_CHARGE_MODE = {}));
const red = "#FF5050";
export const affiliateBookingStatuses = {
    Unconfirmed: {
        value: "unconfirmed",
        label: "Unconfirmed",
        color: "#71e1c3",
        chartColor: "#00a1a1",
    },
    Confirmed: {
        value: "confirmed",
        label: "Confirmed",
        color: "#bcbcbc",
        chartColor: "#00c4c4",
    },
    Canceled: {
        value: "affiliate_canceled",
        label: "Canceled",
        color: red,
        chartColor: "#C0392B",
    },
    DidNotAttend: {
        value: "affiliate_dna",
        label: "Did Not Attend",
        color: "#FFA500",
        chartColor: "#E67E22",
    },
};
//# sourceMappingURL=booking.js.map